import React, { useEffect, useState } from 'react';
import MailChimpSignUp from './MailChimpSignUp/MailChimpSignUp';
import StripePlans from './StripePlans/StripePlans';
import SignUpCognito from './SignUpCognito/SignUpCognito';
import { IUserCreds, ICognitoValues } from 'types/signup';
import { API_PAGES, API_PROJECT, CONSULT_URL, AUTH_USER_TOKEN_KEY, GOOGLE_TAG, API_URL } from 'Constants';
import {
  eventEmiter,
  rxPageId,
} from '../../rx/rxState';
import { Auth } from 'aws-amplify';
import { api, username } from 'utils/api';
import TagManager from 'react-gtm-module';
import { useSearchParams } from 'Hooks/useSearchParams';
import { VersionStripeType } from 'types/signup';

interface IProps {
  onSwitchToLogIn: () => void;
  onClose?: () => void;
  isModal: boolean;
  versionStripePage: VersionStripeType;
  onChangePopupWidth?: (wide: boolean) => void;
  onChangeBackGroundColor: (greyBackground: boolean) => void;
}

TagManager.initialize({
  gtmId: GOOGLE_TAG,
  dataLayer: {
    events: {
      signed_up: 'signed_up',
    }
  }
});

const SignUpWorkflow = (props: IProps) => {
  const [step, setStep] = useState(1);
  const [firstName, setFirstName] = useState('');
  const [email, setEmail] = useState('');
  const [stripeClientId, setStripeClientId] = useState('');

  const {
    query: { session_id },
  } = useSearchParams();

  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    }
  };

  useEffect(() => {
    if (session_id) {
      handleStartCognitoSignUp();
    }
  }, [session_id])

  const handleMailchimpCompleted = (values: IUserCreds) => {
    if (props.onChangePopupWidth) {
      props.onChangePopupWidth(true);
    }
    props.onChangeBackGroundColor(true);
    setEmail(values.email);
    setFirstName(values.firstName);
    setStep(2);
  };

  const handleStartCognitoSignUp = async () => {
    setStep(3);
    const payload = {
      sessionId: session_id
    }
    const stripeResponse = await api(`${API_URL}/stripe?action=af-get-user`, 'POST', payload);
    console.log('stripeResponse', stripeResponse )
    if(stripeResponse){
      if (stripeResponse.name && stripeResponse.name.length) {
        const nameComponents = stripeResponse.name.split(' ')
        setFirstName(nameComponents[0]);
      }
      if (stripeResponse.email) {
        setEmail(stripeResponse.email);
      }
      if (stripeResponse.id) {
        setStripeClientId(stripeResponse.id);
      }
    }
  }

  const signUpComplete = () => {
    window.open(`${CONSULT_URL}/edit/generate`, "_self");
  }

  const handleCognitoFormSubmit = async (userCreds: ICognitoValues) => {
    const { email, password, firstName, lastName} = userCreds;
    const name = `${firstName} ${lastName}`;

    try {
      const cognitoResult = await Auth.signUp({
        username: email,
        password,
        attributes: {
          email,
          name,
          // stripeClientId,
        },
      });
      const { userSub } = cognitoResult;

      const payloadCreateUser = {
        action: 'create-user',
        owner: userSub,
        email,
        name,
        stripeClientId,
      };

      await api(API_PAGES, 'POST', payloadCreateUser);
      const cognitoResponse = await Auth.signIn(userCreds.email, userCreds.password);
      Document.prototype.cognitoUser = cognitoResponse;

      if (cognitoResponse.challengeName === "NEW_PASSWORD_REQUIRED") {
        const email = cognitoResponse.challengeParam.userAttributes.email;
        localStorage.setItem('USER_EMAIL', email);
        window.open(`${CONSULT_URL}/console/signup/${email}`, "_self");
        return;
      }
  
      const owner = username(cognitoResponse.signInUserSession.accessToken.jwtToken);
      const ownerResponse = await api(API_PAGES, 'POST', { action: 'owner', owner, email: userCreds.email});
      localStorage.setItem('USER_ID', ownerResponse.user._id);
      localStorage.setItem('USER_ROLE', ownerResponse.user.role);
      if (ownerResponse.user.subdomain) {
        localStorage.setItem('USER_SUBDOMAIN', ownerResponse.user.subdomain);
      }
      localStorage.setItem(
        AUTH_USER_TOKEN_KEY,
        cognitoResponse.signInUserSession.accessToken.jwtToken
      );
      localStorage.setItem('USER_EMAIL', userCreds.email);
      
      TagManager.dataLayer({
        dataLayer: {
          event: 'signed_up'
        },
      });

      signUpComplete();
    } catch (err: any) {
      console.log('cognito error', err);
      if (err.code === 'UsernameExistsException') {
        props.onSwitchToLogIn();
      }
    }
  }

  /**
   * Could be used if workflow is change or in other place of project
   * @param userSub 
   * @param user 
   */
  const saveGeneratedProjectData = async (userSub: string, user: any) => {
    const payloadCreateGeneralProject = {
      username: userSub,
      name: "First Project",
      userId : user._id,
      action: 'add',
    }
    const generalProject = await api(API_PROJECT, 'POST', payloadCreateGeneralProject);

    const payloadCreateFunnel = {
      name: 'First funnel',
      enabled: true,
      id: generalProject[0]._id,
      action: 'addProduct',
    }

    const funnel = await api(API_PROJECT, 'POST', payloadCreateFunnel);

    rxPageId.next(funnel._id);
    
    eventEmiter.next({
      type: 'save',
      payload: {
        modalView: false,
      }
    });
  }

  return (
    <div style={{width:'100%'}}>
      {step === 1 && (
        <MailChimpSignUp
          onSubmit={(values) => handleMailchimpCompleted(values)}
          onSwitchToLogIn={() => props.onSwitchToLogIn()}
        />
      )}
      {step === 2 && (
        <div>
          <StripePlans
            email={email}
            versionPage={props.versionStripePage}
          />
        </div>
      )}
      {step === 3 && (
        <SignUpCognito
          email={email}
          firstName={firstName}
          onSubmit={handleCognitoFormSubmit}
          onSwitchToLogIn={() => props.onSwitchToLogIn()}
        />
      )}
    </div>
  );
};

export default SignUpWorkflow;
